import React from 'react'
import { composeEventHandlers } from '../utils/compose-event-handlers'
import { OverrideComponentProps } from '../utils/overridable-component-helper'
import { DateRangePickerContext } from './date-range-picker-root'

export const DateRangePickerMonthContext = React.createContext<{ yearMonth: string } | null>(null)

export type DateRangePickerMonthProps<Tag extends React.ElementType<any> = 'div'> = OverrideComponentProps<Tag> & {
  yearMonth: string
}

export const DateRangePickerMonth = React.forwardRef<HTMLDivElement, DateRangePickerMonthProps<any>>(
  ({ yearMonth, as = 'div', ...props }, ref) => {
    const context = React.useContext(DateRangePickerContext)
    return (
      <DateRangePickerMonthContext.Provider value={{ yearMonth }}>
        {React.createElement(as, {
          ...props,
          onMouseLeave: composeEventHandlers(props.onMouseLeave, () => context?.setMouseOver(null)),
          ref
        })}
      </DateRangePickerMonthContext.Provider>
    )
  }
) as WithForwardRefType

DateRangePickerMonth.displayName = 'DateRangePickerMonth'

interface WithForwardRefType extends React.FC<DateRangePickerMonthProps<React.ElementType<any>>> {
  <T extends React.ElementType<any> = 'div'>(
    props: DateRangePickerMonthProps<T>
  ): ReturnType<React.FC<DateRangePickerMonthProps<T>>>
}
